import { z } from 'zod'
import {
  trainerEventFeedbackContextResponseSchema,
  trainerEventFeedbackSummarySchema,
  TRAINER_EVENT_FEEDBACK_READ_CONTRACT_VERSION,
} from './trainer-event-feedback-read'
const trainerFeedbackWriteSideEffectsSchema = z.object({
  db1Written: z.boolean(),
  auditWritten: z.boolean(),
  billingTouched: z.literal(false),
  eventEmitted: z.literal(false),
  uploadTouched: z.literal(false),
  r2Touched: z.literal(false),
  llmTouched: z.literal(false),
  queuePublished: z.literal(false),
  db2Touched: z.literal(false),
}).passthrough()


export const trainerEventFeedbackWriteResponseSchema = z.object({
  contract_version: z.literal(TRAINER_EVENT_FEEDBACK_READ_CONTRACT_VERSION),
  feedback: trainerEventFeedbackSummarySchema,
  idempotentReplay: z.boolean(),
  sideEffects: trainerFeedbackWriteSideEffectsSchema,
}).passthrough()

export const trainerEventFeedbackFormSchemaWriteResponseSchema = trainerEventFeedbackContextResponseSchema

export type TrainerEventFeedbackWriteResponse = z.infer<typeof trainerEventFeedbackWriteResponseSchema>
export type TrainerEventFeedbackFormSchemaWriteResponse = z.infer<typeof trainerEventFeedbackFormSchemaWriteResponseSchema>
